import React from 'react'
import type { LessonDoc } from '../types/LessonDoc'
import LessonCardRenderer from './LessonCardRenderer'

// Xem trước toàn bộ bài học đúng như học sinh sẽ thấy — theo từng PHẦN.
const BuilderPreview: React.FC<{ lesson: LessonDoc }> = ({ lesson }) => {
  const totalCards = lesson.sections.reduce((n, s) => n + s.cards.length, 0)
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-black text-gray-900">{lesson.meta.tieuDe || 'Bài học chưa đặt tên'}</h1>
        {lesson.meta.moTa && <p className="text-gray-500 mt-1">{lesson.meta.moTa}</p>}
      </div>

      {totalCards === 0 ? (
        <div className="p-10 text-center text-gray-400 border border-dashed border-gray-200 rounded-xl">
          Chưa có nội dung. Thêm thẻ vào các phần bên trái.
        </div>
      ) : (
        lesson.sections.map((sec, i) =>
          sec.cards.length === 0 ? null : (
            <section key={sec.id}>
              <h2 className="text-lg font-black text-blue-900 mb-3 flex items-center gap-2">
                <span className="w-7 h-7 rounded-full bg-blue-600 text-white text-sm flex items-center justify-center">
                  {i + 1}
                </span>
                {sec.title}
              </h2>
              <div className="space-y-4">
                {sec.cards.map((card) => (
                  <div key={card.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-5">
                    <LessonCardRenderer card={card} />
                  </div>
                ))}
              </div>
            </section>
          )
        )
      )}
    </div>
  )
}

export default BuilderPreview
